module.exports = __webpack_public_path__ + "static/footbed-09f656ff967a7c44e267490e0f36f3f8.png";